export const isAndroid = function () {
  let isAndroid;
  if (window.androidApi != null) {
    isAndroid = true;
  }
  else {
    isAndroid = false;
  }
  return isAndroid;
}

//获取url中的参数
function getQueryVariable(variable) {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return ('');
}

// 获取sessionId casCookie
export const getUserInfo = function () {
  let userId = '';
  let casCookie = '';
  let sessionId = '';
  if (!isAndroid()) {
    try {
      const person = iosGetPerson();
      userId = person.userId;
      sessionId = person.sessionId;
      casCookie = person.casCookie;
    } catch (error) {
      console.log('ios session', error);
    }
  } else {
    try {
      let tempObj = window.androidApi.getBasicPersionData();
      let parseObj = JSON.parse(tempObj);
      userId = parseObj.userId;
      sessionId = parseObj.sessionId;
      casCookie = parseObj.casCookie;
    } catch (error) {
      console.log('android session', error);
    }
  }

  // 测试

  // return {
  //   userId: '357095',
  //   casCookie: '357095701e1390c4baa96f039cb307288ebdcf',
  //   sessionId: '357095cc930f8dc6fbffb9732696d7af259f57'
  // }

  // 生产

  return {
    userId: userId,
    casCookie: casCookie,
    sessionId: sessionId
  }

}

export const backToLogin = (data) => {
  if (data.errorCode != undefined && data.errorCode == 9999) {
    if (!isAndroid()) {
      try {
        window.location = "js:TC//backToLogin()";
      } catch (error) {
        console.log('back to login ios', error)
      }
    } else {
      try {
        window.androidApi.backToLogin();
      } catch (error) {
        console.log('back to login android', error)
      }
    }
    return;
  }
}



// WEBPACK FOOTER //
// ./src/tools/isAndroid.js